const SCOPE = 'app/talkToUs/';
export const ActionTypes = {
    OPEN_TALK_TO_US: `${SCOPE}OPEN_TALK_TO_US`,
    CLOSE_TALK_TO_US: `${SCOPE}CLOSE_TALK_TO_US`,
};

export const openTalkToUs = () => ({ type: ActionTypes.OPEN_TALK_TO_US });
export const closeTalkToUs = () => ({ type: ActionTypes.CLOSE_TALK_TO_US });
